import React from 'react';
import { useTranslation } from 'react-i18next';
import './ProcessingDelayInput.scss';
import { Option } from '../../../common/interfaces';
import { Dropdown } from '../../FormComponents/Dropdown/Dropdown';
import useProject from '../../../hooks/useProject';
import Help from '../../Help/Help';

const ProcessingDelayInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();
  const options: Option[] = [];

  options.push({ text: `0 seconds`, value: '0' });
  options.push({ text: `0.5 seconds`, value: '0.5' });
  options.push({ text: `1 second`, value: '1' });

  for (let i = 1.5; i <= 10; i += 0.5) {
    options.push({ text: `${i} seconds`, value: i.toString() });
  }

  const onChange = (option: Option) => {
    if (project.encoder) {
      if (project.stream.sourceLanguageIsoCode === project.encoder.languageIsoCode) {
        updateStream({
          aggregatorProcessingDelay: parseFloat(option.value),
        });
      } else {
        updateEncoder(project.encoder, {
          aggregatorProcessingDelay: parseFloat(option.value),
        });
      }
    }
  };

  return (
    <div className="processing-delay-input">
      <div className="input-title">
        {t('producer.inputs.processing-delay.title')}
        <Help
          title="Caption Delay"
          text="This is the time in seconds to hold captions before sending to the viewer.<br/><br/>Adjust if your captions appear too early or late on your video stream.<br/><br/>Use for fine-tuning the timing of your captions in real-time together with the Video Start Delay."
        />
      </div>
      <Dropdown
        value={project.encoder.aggregatorProcessingDelay.toString()}
        options={options}
        onChange={onChange}
        placeholderKey="producer.inputs.processing-delay.placeholder"
        readonly={false}
      />
      <div className="input-component-footer">{t('producer.inputs.processing-delay.footer')}</div>
    </div>
  );
};

export default React.memo(ProcessingDelayInput);
